import { Container } from '@mui/material'
import AccountInfo from '../components/dashboard/AccountInfo'
import SafeAccounts from '../components/dashboard/SafeAccounts'
import Actions from '../components/dashboard/Actions'
import PendingTransactionsBlock from '../components/dashboard/PendingTransactionsBlock'
import TransactionHistoryBlock from '../components/dashboard/TransactionHistoryBlock'
import StatisticsBlock from '../components/dashboard/StatisticsBlock'

export default function Dashboard() {
  return (
    <Container
      maxWidth={false}
      sx={{
        px: { xs: 1, sm: 8, md: '5%', lg: '10%' },
        py: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <AccountInfo />
      <StatisticsBlock />
      <SafeAccounts />
      <Actions />
      <PendingTransactionsBlock />
      <TransactionHistoryBlock />
    </Container>
  )
}
